import React from 'react';
import { injectIntl } from '@atlassian/jira-intl';
import ReleaseMarkerIcon, {
	ICON_TYPES,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/release-bar/marker/icon';
import messages from '@atlassian/jira-portfolio-3-portfolio/src/common/view/messages';
import LegendContainer from '../legend-container';
import LegendItems from '../legend-items';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766src/packages/portfolio-3/portfolio/src/app-export-view/view/main/view-information/test.tsx
import '../styles.module.css';
import type { Props } from './types';

function ReleaseLegend({ intl }: Props) {
	const legendItems = [
		{
			icon: (
				<ReleaseMarkerIcon
					type={ICON_TYPES.ONTRACK}
					totalCount={1}
					// eslint-disable-next-line @typescript-eslint/no-empty-function
					onClick={() => {}}
				/>
			),
			text: intl.formatMessage(messages.onTrackRelease),
		},
		{
			icon: (
				<ReleaseMarkerIcon
					type={ICON_TYPES.OFFTRACK}
					totalCount={1}
					// eslint-disable-next-line @typescript-eslint/no-empty-function
					onClick={() => {}}
				/>
			),
			text: intl.formatMessage(messages.offTrackRelease),
		},
		{
			icon: (
				<ReleaseMarkerIcon
					type={ICON_TYPES.RELEASED}
					totalCount={1}
					// eslint-disable-next-line @typescript-eslint/no-empty-function
					onClick={() => {}}
				/>
			),
			text: intl.formatMessage(messages.releasedRelease),
		},
	];
	return (
		<LegendContainer title={intl.formatMessage(messages.release)}>
			<LegendItems items={legendItems} />
		</LegendContainer>
	);
}

export default injectIntl(ReleaseLegend);
